import {ReducerStatuses} from "services/utils/utils";
import {createSlice} from "@reduxjs/toolkit";
import {union} from "lodash";
import {resetCommentEdit, setCommentToEdit, successCommentEdit} from "features/modals/comment-edit/reducer";

export const initialState = {
    status: ReducerStatuses.IDLE,
    error: "",
    comment: "",
    tags: [],
    show_attachment_modal: false
};

const slice = createSlice({
    name: "commentField",
    initialState,
    reducers: {
        commentStart: (state) => {
            state.status = ReducerStatuses.LOADING;
        },
        commentFailure: (state, {payload}) => {
            state.status = ReducerStatuses.ERROR;
            state.error = payload;
        },
        commentSuccess: (state) => {
            state.status = ReducerStatuses.SUCCESS;
            state.comment = "";
            state.tags = [];
            state.show_attachment_modal = false;
        },
        commentSet: (state, {payload}) => {
            state.comment = payload;
            state.status = ReducerStatuses.IDLE;
            if(!payload) {
                state.tags = [];
            }
        },
        commentSetShowAttachmentModal: (state, {payload}) => {
            state.show_attachment_modal = payload;
        }
    },
    extraReducers: {
        "commentAutosuggest/autosuggestCommentUserSelected": (state, {payload}) => {
            state.tags = union(state.tags, [{ key: `@${payload.replace}`, id: payload.id }]);
            state.comment = state.comment.replace(`@${payload.search}`, `@${payload.replace} `);
        },
        [setCommentToEdit]: (state, {payload}) => {
            state.tags = payload.comment.tags;
            state.comment = payload.comment.clean;
        },
        [resetCommentEdit]: (state) => {
            state.comment = "";
            state.tags = [];
        },
        [successCommentEdit]: (state) => {
            state.comment = "";
            state.tags = [];
        }
    }
});

const { reducer, actions } = slice;

export const {
    commentStart, commentFailure, commentSet, commentSuccess, commentSetShowAttachmentModal
} = actions;

export default reducer;